// layouts/auth/permissions.js

// Mapa de módulos de UI → módulos del backend
// (ajusta los que no cuadren con lo que tu API regresa)
export const MODULE_MAP_UI_TO_API = {
  dashboard: "dashboard",
  profile: "profile",

  // Autenticación
  usuarios: "user",

  // Catálogos
  sellos: "sellos",
  generos: "generos",
  grupos: "grupos",
  formatos: "format",
  grabacion: "recordType",
  parametros: "awardParam",
  reconocimientos: "award",
  nacionalidades: "nationality",

  // Certificaciones
  certificaciones: "certificaciones",

  // Reportes, etc.
  reportes: "reportes",
};

// ─────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────

/**
 * Devuelve true si el usuario puede hacer `action` sobre `uiModule`.
 *
 * @param {object} perms   Objeto de permisos del backend (user.permissions)
 * @param {string} uiModule Nombre del módulo en la UI (routes[].auth.module)
 * @param {string} action  Acción: "read", "create", "update", "delete", etc.
 * @param {boolean} isAdmin Si es admin -> siempre true
 */
export function canAccess(perms, uiModule, action = "read", isAdmin = false) {
  if (isAdmin) return true;
  if (!perms) return false;

  const apiModule = MODULE_MAP_UI_TO_API[uiModule] || uiModule;
  const modPerms = perms[apiModule];

  if (!modPerms) return false;

  // si tu backend manda { read: true, create: false, ... }
  const value = modPerms[action];

  // soporta también arreglos de acciones: { actions: ["read","create"] }
  if (Array.isArray(modPerms.actions)) {
    return modPerms.actions.includes(action);
  }

  return !!value;
}

/**
 * Filtra las rutas del sidenav según permisos.
 *
 * @param {Array} routes      Arreglo de rutas original (routes.js)
 * @param {object} perms      user.permissions
 * @param {object} options
 *   - isAdmin: boolean
 *   - bypass: boolean (DEV_PERMS_ALLOW_ALL)
 */
export function filterRoutesByPerms(routes = [], perms, options = {}) {
  const { isAdmin = false, bypass = false } = options;

  // Admin o bypass → no filtrar nada
  if (isAdmin || bypass) return routes;

  const walk = (list = []) =>
    (list || [])
      .map((r) => {
        // si la ruta no tiene auth, la dejamos pasar
        if (!r.auth) {
          // pero si tiene collapse, igual filtramos sus hijos
          if (Array.isArray(r.collapse)) {
            const children = walk(r.collapse);
            return { ...r, collapse: children };
          }
          return r;
        }

        const { module: uiModule, action = "read" } = r.auth;
        const allowed = canAccess(perms, uiModule, action, isAdmin);
        if (!allowed) return null;

        if (Array.isArray(r.collapse)) {
          const children = walk(r.collapse);
          if (!children.length) return null;
          return { ...r, collapse: children };
        }

        return r;
      })
      .filter(Boolean);

  return walk(routes);
}

/**
 * Flag de bypass de permisos desde localStorage
 * (útil en desarrollo)
 */
export function isPermsBypassOn() {
  try {
    return localStorage.getItem("DEV_PERMS_ALLOW_ALL") === "1";
  } catch {
    return false;
  }
}
